import {RelationshipModel} from "./relationship.model";
import {OrganizationModel} from "./organization.model";
import {UserPhoneUserModel} from "./phone-user.model";
import {ROLE} from "../enums";
import {formatDate} from "../helpers";

export class UserModel {
  uuid: string;
  email: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  default_org: OrganizationModel;
  is_active: boolean;
  totp_enabled: boolean;
  relationship: RelationshipModel;
  relationships: any;
  last_login: string;
  is_staff: boolean;
  // This user's agent slot on the org whose URL fetched them (SD-4590). Always
  // present as a model, never undefined: an older API that does not send the
  // field defaults to `none`, so the delete goes on to the passcode box and the
  // API's own refusal catches it (SD-4583/SD-4592). Failing the other way would
  // block every delete on a build that predates the field.
  phone_user: UserPhoneUserModel;

  constructor(init: any = {}) {
    const data = {
      uuid: null,
      email: '',
      first_name: '',
      last_name: '',
      phone_number: '',
      is_active: false,
      last_login: '',
      relationship: null,
      ...init,
    };

    this.uuid = data.uuid;
    this.email = data.email;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.phone_number = data.phone_number;
    this.default_org = data.default_org;
    this.is_active = data.is_active;
    this.is_staff = data.is_staff;
    this.totp_enabled = data.totp_enabled;
    if (data.last_login)
      this.last_login = formatDate(data.last_login);
    if (data.relationship) {
      this.relationship = new RelationshipModel(data.relationship);
    }
    this.phone_user = new UserPhoneUserModel(data.phone_user);
  }

  isAdmin(): boolean {
    return (this.relationship?.roles || []).some((item) => item === ROLE.ADMIN);
  }
}
